import { jsx as _jsx } from "react/jsx-runtime";
import { useGenerateScriptPanelContext } from '@/hoc/context/generate-script-panel-context';
import { ScriptConfigurationPanel } from '../script-config';
import { ThemeConfigurationPanel } from '../theme-config';
export var GenerateScriptPanel = function (_a) {
    var children = _a.children;
    var _b = useGenerateScriptPanelContext(), configuration = _b.configuration, isThemePanelOpen = _b.isThemePanelOpen, setConfiguration = _b.setConfiguration, setTheme = _b.setTheme, theme = _b.theme;
    if (isThemePanelOpen) {
        return (_jsx(ThemeConfigurationPanel, { theme: theme, setTheme: setTheme, configuration: configuration, setConfiguration: setConfiguration, children: children }));
    }
    return (_jsx(ScriptConfigurationPanel, { configuration: configuration, setConfiguration: setConfiguration }));
};
